
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.322 12.033l-.001-.002a5.2 5.2 0 00-.454-.305c-.147-.087-.309-.157-.47-.227 1.233-.705 1.884-1.822 1.884-3.27 0-1.473-.583-2.616-1.738-3.402-1.026-.683-2.438-1.029-4.198-1.029h-3.349a.5.5 0 000 1h3.349c1.56 0 2.786.29 3.64.858.872.594 1.296 1.436 1.296 2.573 0 1.277-.622 2.146-1.903 2.656a2.255 2.255 0 01-.837.139l-5.546.017a.5.5 0 00.001 1l5.031-.015c.011 0 .02.006.031.006h.008c.896 0 1.667.187 2.289.555.128.076.248.156.359.241.865.665 1.285 1.515 1.285 2.599 0 1.448-.614 2.462-1.876 3.1-.876.448-2.075.676-3.565.676h-3.564a.5.5 0 000 1h3.564c1.649 0 3.002-.265 4.018-.784 1.608-.812 2.423-2.155 2.423-3.991 0-1.397-.564-2.539-1.678-3.394zM12 1a.5.5 0 00-.5.5v21a.5.5 0 001 0v-21A.5.5 0 0012 1zM9.545 11.514a.5.5 0 10.92-.392L7.551 4.305a.53.53 0 00-.46-.304.5.5 0 00-.458.299L.042 19.299a.501.501 0 00.916.402l2.428-5.526h6.618a.5.5 0 000-1H3.826l3.259-7.417 2.46 5.756z"}})])
          )
        }
      }
    